export default __webpack_public_path__ + "static/media/signup-mobile.4dad2714.mp4";